import React, { useState, useEffect, useMemo } from 'react';
import api from '../../services/api';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import DataGrid, {
  Column,
  Paging,
  Pager,
} from 'devextreme-react/data-grid';
import { CheckBox } from "devextreme-react";
import { LoadPanel } from 'devextreme-react/load-panel';
import { useLocation } from 'react-router-dom';

const schema = () =>
  yup.object().shape({
    status: yup.boolean().required("Required"), // Changed to boolean since it's a checkbox
});

const ChangeTasheerStatus = () => {
  const location = useLocation();
  const selectedIds = location.state?.selectedIds;

  const [isLoading, setIsLoading] = useState(false);
  const [applicants, setApplicants] = useState([]);
  const navigate = useNavigate();  

  const {
      register,
      handleSubmit,
      formState: { errors },
      setValue,
      watch
    } = useForm({
      resolver: yupResolver(schema()),
    });

  // Watch the status value
  const status = watch("status");

  useEffect(() => {
    if (!selectedIds || selectedIds.length === 0) {
      console.error("No selected IDs provided.");
      return;
    }

    setIsLoading(true);
    api.post('/Applicants/selected', selectedIds)
      .then((res) => {
        const transformedData = res.data.map((item) => ({
          ...item,
          ID: item.id,
        }));
        setApplicants(transformedData);
      })
      .catch((err) => {
        console.error('Error fetching applicants:', err);
      })
      .finally(() => setIsLoading(false));
  }, [selectedIds]);

  const handleFormSubmit = async (data) => {
    const { status } = data;

    if (!selectedIds || selectedIds.length === 0) {
        alert("Please select at least one applicant.");
        return;
    }

    if (status === undefined) {
        alert("Please fill in all required fields.");
        return;
    }
    
    setIsLoading(true);

    try {
        const response = await api.post(
            `/Applicants/tasheerStatus?status=${encodeURIComponent(status)}`,
            selectedIds,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        navigate("/applicants/applicantlist");
    } catch (error) {
        console.error("Error Response:", error.response?.data);
        alert(JSON.stringify(error.response?.data, null, 2));
    } finally {
        setIsLoading(false);
    }
  };

  const handleStatusChange = (e) => {
    setValue("status", e.value); // Update the form value when checkbox changes
  };

  const columns = useMemo(
    () => [
      { field: 'passportNo', caption: 'Passport No' },
      { field: 'fullName', caption: 'Full Name' },
    ],
    []
  );

  return (
    <div className="container mt-4" style={{ maxWidth: "800px" , maxHeight: "600px", marginBottom: "20px"}}>
      <h5 className="es-label-title">CHANGE TASHEER STATUS</h5>
      <div className="card p-3">
        <form onSubmit={handleSubmit(handleFormSubmit)} className="space-y-4">
          <div className="w-100 h-100 bg-white rounded p-1">
            <LoadPanel
              shadingColor="rgba(0,0,0,0.4)"
              position={{ of: '.dx-datagrid' }}
              visible={isLoading}
              showIndicator={true}
              shading={false}
              showPane={true}
            />      
          </div>
    
          <div className="row mb-1">
            <div className="col-md-3">
              <div className="row">
                <div className="col-sm-2 d-flex align-items-center"></div>
                <div className="col-sm-10 d-flex align-items-center">
                  <CheckBox 
                    className="es-checkbox es-field-label" 
                    value={status} 
                    onValueChanged={handleStatusChange} 
                    text="Tasheer Approved" 
                  />
                  {errors.status && (<i className="bi bi-exclamation-circle text-danger ms-2"></i>)}
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12 d-flex align-items-center row mb-4" style={{paddingTop:15, paddingLeft:35}}>
                  <button type="submit" className="btn es-button">SAVE</button>
                </div>
              </div>
            </div>
            <div className="col-md-9">
              <div className="row">
                <DataGrid
                  dataSource={applicants}
                  showBorders
                  rowAlternationEnabled
                  allowColumnResizing
                  columnAutoWidth
                  focusedRowEnabled
                  keyExpr="ID"
                  height="300px"
                  width="100%"
                >
                  <Paging defaultPageSize={15} />
                  <Pager showPageSizeSelector allowedPageSizes={[10, 20, 50]} showInfo />

                  {columns.map(({ field, caption }) => (
                    <Column key={field} dataField={field} caption={caption} allowFiltering />
                  ))}
                </DataGrid>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangeTasheerStatus;